import headerPhotoSrc from "apps/visits/core/assets/png/header-group-actions-ordering.png";
import type { ReactNode } from "react";

type HeroSectionProps = {
  children: ReactNode;
};

export const HeroLayout = ({ children }: HeroSectionProps) => {
  return (
    <section className="relative w-full bg-white-linen-100 pt-6 pb-12 md:h-[720px]">
      <img
        src={headerPhotoSrc}
        alt=""
        className="absolute top-0 left-0 hidden h-full w-full object-cover object-left md:block md:object-center"
      />

      {children}
    </section>
  );
};
